import Vue from "vue";
import Vuex from "vuex";
import { config } from "@vue/test-utils";
import mocksConfig from "@/__mocks__/config-mock.js";
import mocksRoute from "@/__mocks__/route-mock.js";
import mocksStore from "@/__mocks__/store-mock.js";
import mocksFuncion from "@/__mocks__/funcion-mock.js";
import HTMLSanitize from "../plugins/html-sanitize";

Vue.use(HTMLSanitize);
Vue.use(Vuex);
Vue.set = jest.fn();

config.mocks = {
  ...mocksConfig,
  $route: mocksRoute,
  $router: { push: jest.fn() },
  $store: {
    getters: mocksStore.getters,
    state: mocksStore.state,
    dispatch: mocksStore.dispatch,
    watch: mocksStore.watch,
    computed: mocksStore.computed,
    commit: mocksStore.commit
  },
  ...mocksFuncion
};

Vue.$log = {
  info: jest.fn(),
  error: jest.fn(),
  debug: jest.fn()
};
